export default __webpack_public_path__ + "static/media/08AW1APR66.f4575acb.jpg";